module.exports = __webpack_public_path__ + "img/bx-partainer-timetable-active.db5586cf.svg";